import { useQuery } from 'react-query';
import { useAccount } from '~/contexts/UserAccount/UserAccountContext';
import { useBraintreeRepository } from './rest';

export function useBraintreeToken() {
    const currentAccount = useAccount();
    const { getBraintreeToken } = useBraintreeRepository();

    return useQuery(['braintree-token', currentAccount.id], () => getBraintreeToken(currentAccount.id), {
        // Based on documentation client tokens are valid for 24 hours
        staleTime: 600000,
        useErrorBoundary: true,
    });
}
